import React from "react";
import ClipLoader from "react-spinners/ClipLoader";

export const CenteredSpinner = (props) => {
  return (
    <div
      className="centered-spinner"
      style={{ height: props.height ? props.height : "100vh" }}
    >
      <ClipLoader
        color={props.color ? props.color : "#000"}
        loading
        size={props.size ? props.size : 35}
      />
    </div>
  );
};
